import MovieListContainer from './MovieListContainer';
export default MovieListContainer;